import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import HeaderDos from '../Metodos/Compartidos/HeaderDos';
import HeaderUno from '../Metodos/Compartidos/HeaderUno';
import useConfigAuth from '../../Hooks/useConfigAuth';

// css
import {CuerpoCompleto } from '../Css/StyledHeader.js'
import { Flex } from '../Css/StyledMatematica.js';
import {  ContenedorPrincipal, FlexColumn, InputTemp, LabelTemp, FormTemporal, TituloTemp, FlexButton, BotonNaranja, FaltaDato } from '../Css/MetodosCSS/StyledFormPacTemp.js';

import { crearPacienteScreeningAction } from '../../actions/crearPacienteScreeningActions';
import { setearAlerta, ocultarAlertaAction } from '../../actions/alertaActions';
import Alertas from '../AuxiliaresPaginas/Alertas';


const ScreeningNuevoPaciente = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [config] = useConfigAuth();

    const alerta = useSelector ( (state) => state.alertas.alerta);

    const [disable, setDisable] = useState(false);
    const [incompletoidPacienteScreening, setIncompletoidPacienteScreening] = useState(false);
    const [incompletoFechaNacimientoPaciente, setIncompletoFechaNacimientoPaciente] = useState(false);
    const [incompletoColegio, setIncompletoColegio] = useState(false);
    const [incompletoCurso, setIncompletoCurso] = useState(false);

    const idPacienteScreening = useRef();
    const fechaNacimientoPaciente = useRef();
    const colegio = useRef();
    const curso = useRef();

    const submitPacienteTemporal = (e) => {
        e.preventDefault();
        if(idPacienteScreening.current.value.trim() === '' || 

        fechaNacimientoPaciente.current.value === '' ||
        colegio.current.value.trim() === '' || 
        curso.current.value.trim() === '') {
            const alerta = {
                msg: 'Los campos con una X son obligatorios'
            }
            dispatch( setearAlerta (alerta) );
            if(idPacienteScreening.current.value.trim() === ''){setIncompletoidPacienteScreening(true)} else {setIncompletoidPacienteScreening(false)};
            if(fechaNacimientoPaciente.current.value.trim() === ''){setIncompletoFechaNacimientoPaciente(true)} else {setIncompletoFechaNacimientoPaciente(false)};
            if(colegio.current.value.trim() === ''){setIncompletoColegio(true)} else {setIncompletoColegio(false)};
            if(curso.current.value.trim() === ''){setIncompletoCurso(true)} else {setIncompletoCurso(false)};
            return;
        }
        dispatch( ocultarAlertaAction());

        const informacion = {
            config,
            payload: {
                'id_paciente_screening': idPacienteScreening.current.value,
                'fecha_nacimiento': fechaNacimientoPaciente.current.value,
                'colegio': colegio.current.value,
                'curso': curso.current.value,
            }
        }
        dispatch( crearPacienteScreeningAction(informacion) );
        setDisable(true);
    }

    useEffect(() => {
        if(disable === false){
            return
        }
        navigate("/escritorio/screening");
        setDisable(false);
    }, [disable]);

    return (
        <CuerpoCompleto height="100vh">
            <HeaderUno />
            <HeaderDos link={`/escritorio/screening`} componente={"Nuevo Paciente"} paciente={false} />
            <FlexColumn align="center">
                <Alertas alertaOk={true} errorOk={true} correctoOk={true} />
                <ContenedorPrincipal style={{width: "90%"}}>
                    {alerta ? <Alertas /> : null}
                    <FormTemporal
                        onSubmit={submitPacienteTemporal}
                            >
                        <Flex direction="column" justify="center" alignItems="start">
                            <TituloTemp $color="#23AAAF" style={{alignSelf:"center"}}>Datos del Paciente</TituloTemp>
                            <Flex direction="column" justify="center" alignItems="start" width="85%">
                                <Flex width="100%" margin="0.5rem 0 0.2rem 0">
                                    <LabelTemp htmlFor="id">ID:</LabelTemp>
                                    <InputTemp 
                                        disabled={disable}
                                        type="number"
                                        id="id_paciente_screening"
                                        name="id_paciente_screening"
                                        ref={idPacienteScreening}
                                    />
                                    {!incompletoidPacienteScreening ? null : <FaltaDato>X</FaltaDato>}
                                </Flex>
                                <Flex width="100%" margin="0.5rem 0 0.2rem 0">
                                    <LabelTemp htmlFor="fechaNacimientoPaciente">Fecha Nacimiento:</LabelTemp>
                                    <InputTemp 
                                        disabled={disable}
                                        type="date"
                                        id="fechaNacimientoPaciente"
                                        name="fechaNacimientoPaciente"
                                        // placeholder="Fecha Nacimiento Paciente"
                                        ref={fechaNacimientoPaciente}
                                    />
                                    {!incompletoFechaNacimientoPaciente ? null : <FaltaDato>X</FaltaDato>}
                                </Flex>
                                <Flex width="100%" margin="0.5rem 0 0.2rem 0">
                                    <LabelTemp htmlFor="colegio">Colegio:</LabelTemp>
                                    <InputTemp
                                        disabled={disable}
                                        type="text"
                                        id="colegio"
                                        name="colegio"
                                        // placeholder="Colegio"
                                        ref={colegio}
                                    />
                                    {!incompletoColegio ? null : <FaltaDato>X</FaltaDato>}
                                </Flex>
                                <Flex width="100%" margin="0.5rem 0 0.2rem 0">
                                    <LabelTemp htmlFor="curso">Curso:</LabelTemp>
                                    <InputTemp
                                        disabled={disable}
                                        type="text"
                                        id="curso"
                                        name="curso"
                                        // placeholder="curso"
                                        ref={curso}
                                    />
                                    {!incompletoCurso ? null : <FaltaDato>X</FaltaDato>}
                                </Flex>
                            </Flex>
                        </Flex>
                        <FlexButton justify="flex-end">
                            <BotonNaranja margin="1rem 1rem 1rem 0rem"
                                disabled={disable}
                                type="submit"
                            >
                                CREAR
                            </BotonNaranja>
                        </FlexButton>
                    </FormTemporal>
                </ContenedorPrincipal>
            </FlexColumn>
        </CuerpoCompleto>
    );
}
 
export default ScreeningNuevoPaciente;